/**
 * Dev only. Lets a reviewer see the packer and agent versions of every screen without an API
 * or a second account.
 *
 * It writes one localStorage key that the MSW handlers read. It is rendered only when
 * VITE_MOCK is on, so it cannot appear in a real build, and it grants nothing: in mock mode
 * there is no server to enforce anything, and against a real API the session decides.
 */
const KEY = 'ops.mock.role';

export function MockRoleSwitch() {
  if (import.meta.env.VITE_MOCK !== '1') return null;

  const current = (() => {
    try {
      return window.localStorage.getItem(KEY) ?? 'owner';
    } catch {
      return 'owner';
    }
  })();

  return (
    <label className="o-field">
      <span className="o-field__label">Mock role</span>
      <select
        className="o-select"
        value={current}
        onChange={(event) => {
          try {
            window.localStorage.setItem(KEY, event.target.value);
          } catch {
            // Nothing to do. The demo simply stays on the current role.
          }
          window.location.reload();
        }}
      >
        <option value="owner">owner</option>
        <option value="packer">packer</option>
        <option value="agent">agent</option>
      </select>
    </label>
  );
}
